import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { ProdutoElement } from './core/models/produto';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AppSharedDataService {

  private minimizeMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  minimizeMenu$ = this.minimizeMenu.asObservable();

  private buscar: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(new FormGroup({}));
  buscar$ = this.buscar.asObservable();

  private resetar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  resetar$ = this.resetar.asObservable();

  private produto = new Subject<ProdutoElement>();
  private atualizarImagemProduto: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private closeModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  closeModal$ = this.closeModal.asObservable();

  setMinimizeMenu(val: boolean) {
    this.minimizeMenu.next(val);
  }

  setBuscar(data: any) {
    this.buscar.next(data);
  }

  setResetar(data: any) {
    this.resetar.next(data);
  }

  setProduto(val: ProdutoElement) {
    this.produto.next(val);
  }

  setAtualizarImagemProduto(val: boolean) {
    this.atualizarImagemProduto.next(val);
  }

  setCloseModal(val: boolean) {
    this.closeModal.next(val);
  }

  // private isLogginTeste: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // setIsLogginTeste(val: boolean) {
  //   this.isLogginTeste.next(val);
  // }

  // getIsLogginTeste(): Observable<boolean> {
  //   return this.isLogginTeste.asObservable();
  // }
}

export function determineDeviceType(): Observable<boolean> {
  const screenWidth = window.innerWidth;
  return of((screenWidth < 1024) ? true : false);
}
